module.exports = __webpack_public_path__ + "static/media/github.81ed7990.svg";